import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanListLoadComponent } from './plan-list-load.component';

@NgModule({
  declarations: [PlanListLoadComponent],
  imports: [CommonModule],
  exports: [PlanListLoadComponent],
})
export class PlanListLoadModule {}
